import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Traduit une valeur métier (souvent égale au libellé FR stocké en base).
 * Si la clé est absente, renvoie la valeur brute.
 */
@Pipe({
  name: 'i18nValue',
  standalone: true,
})
export class I18nValuePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(
    value: string | null | undefined,
    prefix: string
  ): string {
    if (value == null || value === '') {
      return '';
    }
    const key = `${prefix}.${value}`;
    const translated = this.translate.instant(key);
    return translated === key ? value : translated;
  }
}
